import React, { useMemo } from 'react';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from '@material-ui/core/Tooltip';

import { DialogContentProps } from 'components/dialog/types';

import {
  ImageViewer,
  ImageViewerProps,
} from 'components/image-viewer/image-viewer';

export const ImageViewerDialog = <T, K>({
  initialValues,
  onClose,
}: DialogContentProps<ImageViewerProps<T, K>>) => {
  const imageViewerProps = initialValues as ImageViewerProps<T, K>;

  const toolbarButtons = useMemo(() => {
    const closeButton = (
      <Tooltip title="zavřít" placement="bottom">
        <Button onClick={onClose}>
          <CloseIcon />
        </Button>
      </Tooltip>
    );

    return [...(initialValues?.toolbarButtons ?? []), closeButton];
  }, [initialValues?.toolbarButtons, onClose]);

  const props = useMemo<ImageViewerProps<T, K>>(
    () => ({
      ...imageViewerProps,
      toolbarButtons,
      minHeight: 200,
    }),
    [imageViewerProps, toolbarButtons]
  );

  return <ImageViewer autofocus {...props} />;
};
